// extracted by mini-css-extract-plugin
export default {"loadingBar":"text_loader-module__loadingBar--xHuxw","placeHolderShimmer":"text_loader-module__placeHolderShimmer--2ETHA"};